import { useEffect } from 'react';
import { goToTopOfPage } from '../../../../helper/helper';
import { useSelector } from 'react-redux';
import { RootState } from '../../../../store/store';
import { updateCover } from '../../services/story.service';
import { FrontCoverPagesProps } from '../../models/FrontCoverPagesProps.interface';
import BookCoverDisplay from './components/BookCoverDisplay';
import BookContent from './components/BookContent';
import { ListViewMode } from '../ListViewModeSwitcher';

const FrontCoverPages = ({
                           bookData,
                           setShowBookCover,
                           showBookCover,
                           editCover = false,
                           selectedCoverUrl,
                           displayBookPages,
                           mode,
                           setStateData,
                           stateData
                         }: FrontCoverPagesProps) => {
  const user = useSelector((state: RootState) => state.user.user);

  const handleUpdateCover = async () => {
    const coverImage = bookData?.pages?.page1?.imageURLwebp || bookData?.pages?.page1?.imageURL;
    if (bookData?.bookId && coverImage) {
      await updateCover({
        bookId: bookData.bookId,
        coverURL: coverImage,
        displayBookPages
      });
    }
  };

  useEffect(() => {
    goToTopOfPage();
  }, []);

  useEffect(() => {
    if ((bookData?.pages?.page1?.imageURLwebp || bookData?.pages?.page1?.imageURL) && !bookData?.coverURL) handleUpdateCover();
  }, [bookData?.pages?.page1?.imageURLwebp, bookData?.pages?.page1?.imageURL, bookData?.coverURL]);

  return (
    <div className={` ${mode === ListViewMode.PAGE ? ' ' : 'grid grid-cols-1 lg:grid-cols-2 gap-4 mb-4 '}`}>
      <BookCoverDisplay
        mode={mode}
        bookData={bookData}
        user={user}
        editCover={editCover}
        showBookCover={showBookCover}
        setShowBookCover={setShowBookCover}
        stateData={stateData}
        setStateData={setStateData}
      />

      <BookContent
        mode={mode}
        bookData={bookData}
        user={user}
      />
    </div>
  );
};
export default FrontCoverPages;
